import { Serializable } from '../../../core/models/serializable';

export class CvDatabaseClicksReportModel
  implements Serializable<CvDatabaseClicksReportModel>
{
  fromObject(object: any): CvDatabaseClicksReportModel {
    Object.assign(this, object);
    this.clicks = {};
    this.totals = {};

    if (object && object.clicks) {
      var keys = Object.keys(object.clicks);
      keys.forEach((k) => {
        let dict = object.clicks[k];
        if (dict) {
          var keys2 = Object.keys(dict);
          this.clicks[k] = {};
          keys2.forEach((k2) => {
            let t = new ClickReport();
            t = t.fromObject(dict[k2]);
            this.clicks[k][k2] = t;
          });
        }
      });
    }
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public clicks: { [date: string]: { [customer: string]: ClickReport } };

  private totals: { [customer: string]: number };

  public GetTotal(customer: string) {
    if (!(customer in this.totals)) {
      this.totals[customer] = Object.keys(this.clicks)
        .map((k) => this.clicks[k][customer])
        .reduce((a, b) => a + (b ? b.count : 0), 0);
    }
    return this.totals[customer];
  }
}

export class ClickReport implements Serializable<ClickReport> {
  fromObject(object: any): ClickReport {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public customerId: number;
  public count: number;
}
